import actions from "./actions";

import {
  errorMutations,
  loadingMutations,
  replaceOrSetArrayObjectsValue,
  resetErrorsAndLoading,
  setter,
  getter,
  proxy
} from "@/store/utils";

import { FETCH_CSV_HISTORY } from "./types";
import { sortSearchPaginateMutations } from "@/store/common/mutations";
import { sortSearchPaginateGetters } from "@/store/common/getters";

const state = {
  isLoading: false,
  errors: null,
  hasNext: null,
  hasPrev: null,
  pages: 1,
  total: 0,
  currentPage: 1,
  itemsPerPage: 25,
  sorting: {
    key: "created_at",
    value: false
  },
  csvHistoryList: [],
  searchString: ""
};

const getters = {
  isLoading: getter("isLoading"),
  total: getter("total"),
  currentPage: getter("currentPage"),
  itemsPerPage: getter("itemsPerPage"),
  pages: getter("pages"),
  csvHistoryList: getter("csvHistoryList"),
  ...sortSearchPaginateGetters
};

const mutations = {
  [FETCH_CSV_HISTORY.success](state, { payload }) {
    setter("csvHistoryList", payload.items)(state);
    setter("pages", payload.pages)(state);
    setter("total", payload.total)(state);
    resetErrorsAndLoading(state);
  },

  ...sortSearchPaginateMutations,

  ...loadingMutations([FETCH_CSV_HISTORY.request]),

  ...errorMutations([FETCH_CSV_HISTORY.error])
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
